import { eventEmitter } from "events/index";

export default function registerSpliceEvents() {
  eventEmitter.on("splice:video_spliced", (data) => {
    window.analytics.track("video_spliced", data);
  });
}
